export default __webpack_public_path__ + "static/media/plurato-sailfin-efoil.53e781a8.mp4";